import { window } from 'browser-monads';

export enum TestOption {
	A = 'A',
	B = 'B',
	DEFAULT = 'A',
}

const AB_TEST_URI = 'abTest';
export const AB_TEST_ITEM_KEY = 'ab-test';

export function getABFlow(): TestOption {
	const search = window.location.search;
	let option = TestOption.DEFAULT;

	switch (true) {
		case process.env.GATSBY_AB_TEST !== 'true':
			break;

		case !!ABTestOption.option:
			if (!!ABTestOption.option) {
				option = ABTestOption.option;
			}
			break;

		case uriWithTestOption(search):
			const uriOption = getUriOption(search);
			if (uriOption) {
				window.sessionStorage.setItem(AB_TEST_ITEM_KEY, uriOption);
				ABTestOption.setOption(uriOption);
				option = uriOption;
			}

			break;

		case window.sessionStorage.getItem(AB_TEST_ITEM_KEY) !== null:
			const localStorageOption =
				window.sessionStorage.getItem(AB_TEST_ITEM_KEY);
			if (isTestOption(localStorageOption)) {
				ABTestOption.setOption(localStorageOption);
				option = localStorageOption;
			}
			break;

		default:
			const generatedOption = generateOption();
			window.sessionStorage.setItem(AB_TEST_ITEM_KEY, generatedOption);
			ABTestOption.setOption(generatedOption);
			option = generatedOption;
	}
	return option;
}

const generateOption = () => {
	const FIFTY_PERCENT = 0.5;
	return Math.random() > FIFTY_PERCENT ? TestOption.A : TestOption.B;
};

export const isTestOption = (option: string | null): option is TestOption => {
	if (!option) {
		return false;
	}
	if (!(option in TestOption)) {
		console.error(
			`Provided string does not match in the available AB types, please check if typo. Possible matches are: ${Object.values(
				TestOption
			).join(', ')}`
		);
		return false;
	}
	return true;
};

export class ABTestOption {
	static option: TestOption | undefined;

	static setOption(t: string) {
		if (isTestOption(t)) {
			this.option = t;
		}
	}
}

const getUriOption = (search: string): TestOption | null => {
	const regex = new RegExp(AB_TEST_URI, 'i');
	let uriOption: null | TestOption = null;
	new URLSearchParams(search).forEach((value, key) => {
		if (regex.test(key) && isTestOption(value)) {
			uriOption = value;
		}
	});
	return uriOption;
};

const uriWithTestOption = (search: string) => {
	const uriOption = getUriOption(search);

	return isTestOption(uriOption);
};
